import { ReactComponent as DiplomaLocked } from "assets/images/diplomaLockedSmall.svg"
import { formatDate } from "format"
import { Icon } from "materia"
import { useTranslation } from "react-i18next"
import { modifiers } from "ui-tools"

import s from "./Deadline.module.scss"

type DeadlineVariant = "overdue" | "dueDate"
type DeadlineSize = "small" | "medium"

export const Deadline = ({
  variant,
  size,
  deadline,
  hasDiploma,
}: {
  variant: DeadlineVariant
  size: DeadlineSize
  deadline?: string | undefined | null
  hasDiploma?: boolean
}) => {
  const { t, i18n } = useTranslation()
  const translationKey = getVariantTranslationKey(variant)

  const formattedDeadline = formatDeadlineDate(deadline, i18n.language)
  const title = t(translationKey)

  return (
    <div className={modifiers(s, "deadline", variant, size)}>
      {hasDiploma ? (
        <DiplomaLocked className={s.deadline__diplomaIcon} />
      ) : (
        <Icon icon={getVariantIcon(variant)} size={size} />
      )}
      <span className={s.deadline__title}>{title}</span>
      {formattedDeadline !== undefined && <span>- {formattedDeadline}</span>}
    </div>
  )
}

const getVariantIcon = (variant: DeadlineVariant) => {
  switch (variant) {
    case "dueDate":
      return "Clock"
    default:
      return "ExclamationMarkCircle"
  }
}

const getVariantTranslationKey = (variant: DeadlineVariant) => {
  switch (variant) {
    case "dueDate":
      return "product.DUE_DATE"
    default:
      return "product.OVERDUE"
  }
}

const formatDeadlineDate = (
  date: string | undefined | null,
  locale: string
) => {
  if (!date) return
  return formatDate(date, locale, {
    year: "numeric",
    month: "short",
    day: "numeric",
  })
}
